/* Copyright (c) 2017 Backpack Health LLC */

const RouteNames = {

  aboutBackpack: () => '/about',
  contactUs: () => '/contact-us',
  dataConnections: () => '/data-connections',
  dataConnectionsSettings: () => '/data-connections/settings',

  accountSettings: () => '/account-settings',

  termsAndPrivacy: () => '/terms',

  changeEmail: () => '/account-settings/changeEmail',
  changePassword: () => '/account-settings/changePassword',
  changePasswordMfa: () => '/profile/account/mfa/changePassword',

  share: () => '/sharecard',
  newShareCard: () => '/sharecard/new',
  shareScrollToCard: (cardId) => `/sharecard#${cardId}`,
  createShareCard: (definitionId) => `/sharecard/create/${definitionId}`,
  shareCardView: (shareCardId) => `/sharecard/${shareCardId}/view`,
  shareCard: (shareCardId) => `/sharecard/${shareCardId}`,
  shareCardRegisterNewJewelry: (shareCardId) => `/sharecard/${shareCardId}/medical-jewelry-register`,

  createHealthEntry: (category) => `/healthEntry/create/${category}`,
  healthEntry: (healthEntryId) => `/healthEntry/${healthEntryId}`,
  healthEntryNew: (healthEntryId) => `/healthEntry/${healthEntryId}?mode=create`,
  healthEntryChangeSearch: (healthEntryId) => `/healthEntry/${healthEntryId}/change/search`,
  healthEntryChangeList: (healthEntryId) => `/healthEntry/${healthEntryId}/change/list`,
  healthEntryWhen: (healthEntryId) => `/healthEntry/${healthEntryId}/when`,
  healthEntryDiagnosis: (healthEntryId) => `/healthEntry/${healthEntryId}/diagnosis`,
  healthEntryAnatomy: (healthEntryId) => `/healthEntry/${healthEntryId}/anatomy`,
  healthEntryStoppingReason: (healthEntryId) => `/healthEntry/${healthEntryId}/stoppingReason`,
  healthEntryReaction: (healthEntryId) => `/healthEntry/${healthEntryId}/reaction`,
  healthEntryAmountAndFrequency: (healthEntryId) => `/healthEntry/${healthEntryId}/amountAndFrequency`,
  healthEntryFrequencyUnit: (healthEntryId, groupName) => `/healthEntry/${healthEntryId}/frequencyUnit/${groupName}`,
  healthEntryAmountUnit: (healthEntryId) => `/healthEntry/${healthEntryId}/amountUnit`,

  healthEntryMultiOccurrenceValues: (healthEntryId, queryParam = '') => `/healthEntry/${healthEntryId}/values${queryParam}`,
  healthEntryMultiOccurrenceShareCards: (healthEntryId, queryParam = '') => `/healthEntry/${healthEntryId}/shareCards${queryParam}`,

  healthEntryValueAmount: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}/amount`,
  healthEntryValueGeneVariant: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}/gene-variant`,
  healthEntryValueGeneMutationType: (healthEntryId = ':healthEntryId', valueId = ':valueId') => `/healthEntry/${healthEntryId}/values/${valueId}/gene-mutation-type`,
  healthEntryValueGeneDNAChange: (healthEntryId = ':healthEntryId', valueId = ':valueId') => `/healthEntry/${healthEntryId}/values/${valueId}/gene-dna-change`,
  healthEntryValueGeneProteinChange: (healthEntryId = ':healthEntryId', valueId = ':valueId') => `/healthEntry/${healthEntryId}/values/${valueId}/gene-protein-change`,
  healthEntryValueGeneExon: (healthEntryId = ':healthEntryId', valueId = ':valueId') => `/healthEntry/${healthEntryId}/values/${valueId}/gene-exon`,
  healthEntryValueGeneZygosity: (healthEntryId = ':healthEntryId', valueId = ':valueId') => `/healthEntry/${healthEntryId}/values/${valueId}/gene-zygosity`,

  contactAttach: (attachmentType?, parentId?) => {
    const queryParam = (attachmentType && parentId) ? `?attachmentType=${attachmentType}&parentId=${parentId}` : '';
    return `/contacts/attach${queryParam}`;
  },
  contactAttachNew: (attachmentType?, parentId?) => {
    const queryParam = (attachmentType && parentId) ? `?attachmentType=${attachmentType}&parentId=${parentId}` : '';
    return `/contacts/attach/new${queryParam}`;
  },

  trackableObservationList: (trackableId: any = ':trackableId') => `/trackables/${trackableId}`,
  trackableObservation: (trackableId: any = ':trackableId', observationId: any = ':observationId') => `/trackables/${trackableId}/observations/${observationId}`,

  contactList: () => '/contacts',
  contactAdd: () => '/contacts/add',
  contact: (contactId: any = ':contactId', referrer?) => (referrer ? `/contacts/${contactId}?referrer=${referrer}` : `/contacts/${contactId}`),
  contactEdit: (contactId: any = ':contactId', referrer?) => (referrer ? `/contacts/${contactId}/edit?referrer=${referrer}` : `/contacts/${contactId}/edit`),
  contactEditNew: () => '/contacts/add/edit',
  contactCustomSpecialty: (contactId = ':contactId') => `/contacts/${contactId}/specialty/custom`,
  contactSpecialty: (contactId = ':contactId') => `/contacts/${contactId}/specialty`,
  contactRelationship: (contactId: any = ':contactId') => `/contacts/${contactId}/relationship`,
  contactCustomRelationship: (contactId: any = ':contactId') => `/contacts/${contactId}/relationship/custom`,
  contactHealthcareProxy: (contactId: any = ':contactId') => `/contacts/${contactId}/healthcare-proxy`,
  contactDetail: (contactId = ':contactId', detailId = ':detailId') => `/contacts/${contactId}/detail-label/${detailId}`,
  contactPhone: (contactId = ':contactId', detailId = ':detailId') => `/contacts/${contactId}/detail-label/${detailId}?type=phone`,
  contactEmail: (contactId = ':contactId', detailId = ':detailId') => `/contacts/${contactId}/detail-label/${detailId}?type=email`,
  contactWebsite: (contactId = ':contactId', detailId = ':detailId') => `/contacts/${contactId}/detail-label/${detailId}?type=website`,
  contactAddress: (contactId = ':contactId', detailId = ':detailId') => `/contacts/${contactId}/detail-label/${detailId}?type=address`,

  reviewPendingData: () => '/review-pending-data',

  healthEntryValue: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}`,
  healthEntryValueNew: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}?mode=create`,
  healthEntryValueWhen: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}/when`,

  healthEntryValueUnit: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}/unit`,
  healthEntryValueDescriptor: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}/descriptor`,

  fileUpload: (attachmentType?, parentId?) => {
    const queryParam = (attachmentType && parentId) ? `?attachmentType=${attachmentType}&parentId=${parentId}` : '';
    return `/files/upload${queryParam}`;
  },
  file: (fileId, attachmentType?, parentId?) => {
    const queryParam = (attachmentType && parentId) ? `?attachmentType=${attachmentType}&parentId=${parentId}` : '';
    return `/files/${fileId}${queryParam}`;
  },
  fileUploadError: () => '/files/error',

  addNote: () => '/notes/create',
  note: (noteId) => `/notes/${noteId}`,

  createHEValueComment: (healthEntryId, valueId) => `/healthEntry/${healthEntryId}/values/${valueId}/comment/create`,
  createHEComment: (healthEntryId) => `/healthEntry/${healthEntryId}/comment/create`,
  healthEntryComment: (healthEntryId = ':healthEntryId', commentId = ':commentId') => {
    return `/healthEntry/${healthEntryId}/comment/${commentId}`;
  },
  healthEntryValueComment: (healthEntryId = ':healthEntryId', valueId = ':valueId', commentId = ':commentId') => {
    return `/healthEntry/${healthEntryId}/values/${valueId}/comment/${commentId}`;
  },

  createTrackableComment: (trackableId: any = ':trackableId') => `/trackables/${trackableId}/comment/create`,
  trackableComment: (trackableId: any = ':trackableId', commentId: any = ':commentId') => `/trackables/${trackableId}/comment/${commentId}`,

  home: () => '/mybackpack',
  deleteAccountSuccess: () => '/goodbye',
  deleteAccountConfirm: () => '/isthisgoodbye',
  deleteAccountSurvey: () => '/delete-account-survey',

  profile: () => '/profile',
  profileInfo: () => '/profile/info',
  profileSettings: () => '/profile/settings',
  setPreferredLanguage: () => '/account-settings/language',
  profileAccess: () => '/profile/access',
  profileInviteOwner: () => '/profile/access/inviteOwner',
  profileInviteSelf: () => '/profile/access/inviteSelf',
  profileRemoveOwnership: () => '/profile/access/removeOwnership',
  profileAccessPermissions: (ownerProfileId) => `/profile/access/${ownerProfileId}/permissions`,
  profilePrivacy: () => '/profile/privacy',

  profileName: () => '/profile/info/name',
  profileDateOfBirth: () => '/profile/info/dob',
  profileGender: () => '/profile/info/gender',
  profileBloodType: () => '/profile/info/bloodType',
  profileRace: () => '/profile/info/race',
  profileResidence: () => '/profile/info/residence',
  profileRaceSelfIdentity: () => '/profile/info/raceSelfIdentity',

  profilePhotoCrop: () => '/profile/photo/crop',
  profilePhotoError: () => '/profile/photo/error/dimension',

  profileDelete: () => '/profile/delete',

  createDependentProfile: () => '/profile/new',

  profileSetup: () => '/profilesetup',
  newProfileSetup: () => '/new-profile-setup',
  profileSetupIntro: () => '/profilesetup/intro',
  profileSetupName: () => '/profilesetup/name',
  profileSetupDateOfBirth: () => '/profilesetup/dob',
  profileSetupGender: () => '/profilesetup/gender',
  profileSetupBirthSex: () => '/profilesetup/birthSex',

  mfaEnabled: () => '/profile/account/mfa',
  mfaSetMobileNumber: () => '/account-settings/mfa/setMobileNumber',
  mfaVerifyMobileNumber: () => '/profile/account/mfa/verifyMobileNumber',
  communicationOptions: () => '/account-settings/communication-options',

  healthInfo: () => '/mybackpack',
  myBackpack: () => '/mybackpack',
  myBackpackAll: () => '/mybackpack',
  myBackpackFiles: () => '/mybackpack/files',
  myBackpackNotes: () => '/mybackpack/notes',
  myBackpackSelectionFiles: (attachmentType?, parentId?) => {
    const queryParam = (attachmentType && parentId) ? `?attachmentType=${attachmentType}&parentId=${parentId}` : '';
    return `/mybackpack/selection/files${queryParam}`;
  },
  groups: () => '/mybackpack/groups',
  myGroups: () => '/mybackpack/groups',
  intendedGroup: () => '/mybackpack/groups/intended',
  findGroup: () => '/mybackpack/groups/find',
  myGroupInfo: (groupId = ':groupId') => `/mybackpack/groups/${groupId}`,
  joinGroup: (groupId = ':groupId', profileId?, backUrl?) => {
    let params = profileId ? `?profileId=${profileId}` : '';
    if (backUrl) {
      const backUrlParam = `backUrl=${backUrl}`;
      params += params ? `&${backUrlParam}` : `?${backUrlParam}`;
    }

    return `/mybackpack/groups/${groupId}/join${params}`;
  },
  joinGroupInstructions: (group: string = ':group') => `/join/${group}`,
  groupInfo: (groupId: any = ':groupId') => `/mybackpack/groups/${groupId}/info`,
  leaveGroup: (groupId: any = ':groupId') => `/mybackpack/groups/${groupId}/leave`,

  groupResources: (groupId: any = ':groupId') => `/mybackpack/groups/${groupId}/resources`,

  surveys: (groupId: any = ':groupId') => `/mybackpack/groups/${groupId}/surveys`,
  surveyIntro: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}`,
  surveyResume: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}?resume=true`,
  surveyReview: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}/review`,
  surveyFirstQuestion: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}/question`,
  surveyLastQuestion: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}/question/review`,
  surveySubmitted: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}/submitted`,
  surveyComplete: (groupId: any = ':groupId', surveyId: any = ':surveyId') => `/mybackpack/groups/${groupId}/survey/${surveyId}/complete`,

  actions: (queryParams = {}) => {
    const entries = Object.entries(queryParams);

    if (entries.length === 0) { return '/actions'; }

    const params = entries.reduce((acc, [k, v]) => {
      return `${acc}${k}=${v}&`;
    }, '?');
    return `/actions${params}`;
  },
  trackableReminderSettings: (trackableId: any = ':trackableId') => `/trackables/${trackableId}/reminder`,
  trackableReminderDuration: (trackableId: any = ':trackableId') => `/trackables/${trackableId}/reminder/duration`,
  trackableReminderTime: (trackableId: any = ':trackableId', timeId: any = ':timeId') => `/trackables/${trackableId}/reminder/time/${timeId}`,
  trackableReminderTimeNew: (trackableId: any = ':trackableId') => `/trackables/${trackableId}/reminder/time/new`,
  trackableReminderFrequency: (trackableId: any = ':trackableId') => `/trackables/${trackableId}/reminder/frequency`,

  notifications: () => '/notifications',
  userSetup: () => '/user-setup',
  newUserSetup: () => '/new-user-setup',

  token: (token: any = ':token') => `/token/${token}`,
  verify: (duration) => `/verify?duration=${duration}`,
  setPasswordWithToken: (tokenId) => `/setpassword/${tokenId}`,
  setPasswordWithForgot: (tokenId) => `/setpassword/verify/${tokenId}`,
  login: () => '/login',
  loginpassword: () => '/loginpassword',
  signup: () => '/signup',
  signupIntro: () => '/signup/intro',

  forgotPassword: () => '/forgotpassword',
  forgotPasswordSent: () => '/forgotpassword/checkinbox',

  intro: () => '/intro',
  introEnd: () => '/intro/end',
  destinationLink: (token: any = ':token') => `/redirect/${token}`,
};

export default RouteNames;
